'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-handler-names */


/*
Pflichtproperties:
Usable={true/false} 
Text={ "OK" }   
OnClick={ ( )=>{ this.Close();if(this.props.Click){ click(); } }}

optional:
Width={150} style={{ marginTop: '2px !important'}} Float={'right'}
ref={"Register"}
style={{ margin: 25}}
*/
var ExtendedButton = function (_Component) {
    _inherits(ExtendedButton, _Component);

    function ExtendedButton(props) {
        _classCallCheck(this, ExtendedButton);

        var _this = _possibleConstructorReturn(this, (ExtendedButton.__proto__ || Object.getPrototypeOf(ExtendedButton)).call(this, props));

        _this.state = {};
        _this.state.usable = _this.props.Usable;
        _this.state.Text = _this.props.Text;
        _this.state.OnClick = _this.props.OnClick;
        return _this;
    }

    _createClass(ExtendedButton, [{
        key: 'removeFocusedElements',
        value: function removeFocusedElements() {
            var elements = document.getElementsByClassName('extendedButton');
            var i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedButton');
            }

            elements = document.getElementsByClassName('focusedCheckBox');
            i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedCheckBox');
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            (0, _jquery2.default)("#" + id).select();

            this.removeFocusedElements();

            (0, _jquery2.default)("#" + id).addClass("extendedButton focusedButton");
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (event.keyCode === 9) {
                    var docs = document.querySelectorAll('div.ss-selected-option,input,button,select');
                    var maxId = docs.length;
                    var aktive = document.activeElement.id;
                    var i = void 0;

                    for (i = 0; i <= maxId - 1; i++) {

                        if (docs[i].id === aktive) {

                            if (i === maxId - 1) {

                                this.removeFocusedElements();

                                docs[i].blur();

                                break;
                            } else {
                                if (event.shiftKey && event.keyCode === 9) {

                                    for (var j = i - 1; j >= 0; j--) {
                                        if (!docs[j].readOnly) {

                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {

                                            var _event = new Event("click");
                                            docs[j].dispatchEvent(_event);
                                            break;
                                        }
                                    }
                                } else {

                                    for (var j = i + 1; j <= maxId - 1; j++) {
                                        if (!docs[j].readOnly) {

                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {

                                            var _event2 = new Event("click");
                                            docs[j].dispatchEvent(_event2);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var text = this.state.Text;
            var Style = null;

            var controlName = '';
            var inp = '';

            var Tooltip = '';
            if (this.props.Tooltip) {
                Tooltip = _react2.default.createElement(
                    'span',
                    null,
                    this.props.Tooltip
                );
            }

            if (!this.props.Type) {
                if (this.props.Width) {
                    Style = { width: this.props.Width, float: this.props.Float, height: this.props.Height, backgroundColor: this.props.BackgroundColor };
                }

                if (this.state.usable) {
                    controlName = "extendedButton";
                    inp = _react2.default.createElement(
                        'button',
                        {
                            style: Style,
                            onClick: function onClick() {
                                if (_this2.state.OnClick) {
                                    _this2.state.OnClick();
                                }
                            },
                            onFocus: function onFocus() {
                                _this2.focus(_this2.props.Id);
                            },
                            onBlur: function onBlur(e) {
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }_this2.tab(e, _this2);
                            },
                            onKeyDown: function onKeyDown(e) {
                                if (e.keyCode === 9) {
                                    e.preventDefault();
                                }if (_this2.state.OnKeyDown) {
                                    _this2.state.OnKeyDown();
                                }_this2.tab(e, _this2);
                            },
                            className: controlName,
                            id: this.props.Id },
                        text,
                        Tooltip
                    );
                } else {
                    controlName = "disabledExtendedButton";
                    inp = _react2.default.createElement(
                        'button',
                        {
                            style: Style,
                            className: controlName,
                            onFocus: function onFocus() {
                                _this2.focus(_this2.props.Id);
                            },
                            onBlur: function onBlur(e) {
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }_this2.tab(e, _this2);
                            },
                            onKeyDown: function onKeyDown(e) {
                                if (e.keyCode === 9) {
                                    e.preventDefault();
                                }if (_this2.state.OnKeyDown) {
                                    _this2.state.OnKeyDown();
                                }_this2.tab(e, _this2);
                            },
                            id: this.props.Id },
                        text,
                        Tooltip
                    );
                }
            } else if (this.props.Type === "Round") {
                if (this.props.Width) {
                    Style = { width: this.props.Width, float: this.props.Float, height: this.props.Height, backgroundColor: this.props.BackgroundColor };
                }

                if (this.state.usable) {
                    controlName = "roundExtendedButton";
                    inp = _react2.default.createElement(
                        'button',
                        {
                            style: Style,
                            onClick: this.state.OnClick,
                            onFocus: function onFocus() {
                                _this2.focus(_this2.props.Id);
                            },
                            onBlur: function onBlur(e) {
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }_this2.tab(e, _this2);
                            },
                            onKeyDown: function onKeyDown(e) {
                                if (e.keyCode === 9) {
                                    e.preventDefault();
                                }if (_this2.state.OnKeyDown) {
                                    _this2.state.OnKeyDown();
                                }_this2.tab(e, _this2);
                            },
                            className: controlName,
                            id: this.props.Id },
                        text,
                        Tooltip
                    );
                } else {
                    controlName = "roundDisabledExtendedButton";
                    inp = _react2.default.createElement(
                        'button',
                        {
                            style: Style,
                            className: controlName,
                            onFocus: function onFocus() {
                                _this2.focus(_this2.props.Id);
                            },
                            onBlur: function onBlur(e) {
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }_this2.tab(e, _this2);
                            },
                            onKeyDown: function onKeyDown(e) {
                                if (e.keyCode === 9) {
                                    e.preventDefault();
                                }if (_this2.state.OnKeyDown) {
                                    _this2.state.OnKeyDown();
                                }_this2.tab(e, _this2);
                            },
                            id: this.props.Id },
                        text,
                        Tooltip
                    );
                }
            }
            return _react2.default.createElement(
                'div',
                { className: "ex" },
                inp
            );
        }
    }]);

    return ExtendedButton;
}(_react.Component);

exports.default = ExtendedButton;